import { useNotificationTemplateQuery } from '@client/graphql/__generated__/main-operations';

export const useNotificationTemplate = (id: string | undefined) => {
  const { data, loading, error, refetch } = useNotificationTemplateQuery({
    variables: { id: id ?? '' },
    skip: !id,
  });

  return {
    template: data?.notificationTemplate ?? null,
    loading,
    error,
    refetch,
  };
};
